import * as React from "react";
const SvgCheckPlain = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: props.size || "1em",
    height: props.size || "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ...props
  },
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement("path", { d: "M5.475 13.293 1.212 9.142a.693.693 0 0 1 0-.998.738.738 0 0 1 1.025 0l3.704 3.609 7.781-9.001a.736.736 0 0 1 1.02-.086.694.694 0 0 1 .088.995l-8.29 9.588a.736.736 0 0 1-.522.251h-.031a.733.733 0 0 1-.512-.207Z" })
);
const SvgCheckPlain$1 = SvgCheckPlain;
export {
  SvgCheckPlain$1 as default
};
